import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface State { failed: boolean; technicalMessage?: string; }

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Falha inesperada na interface LEITOUR', error.name, error.message, info.componentStack);
    this.setState({ technicalMessage: `${error.name}: ${error.message}` });
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-error" role="alert">
        <AlertTriangle />
        <h1>Algo saiu do lugar.</h1>
        <p>Seus dados locais não foram apagados. Reabra a tela; se o problema continuar, exporte um backup em Configurações.</p>
        {this.state.technicalMessage && <small>{this.state.technicalMessage}</small>}
        <button className="button button--primary" onClick={() => window.location.reload()}>Reabrir LEITOUR</button>
      </main>
    );
  }
}
